"use client";

import { useId } from "react";
import PropTypes from "prop-types";

import styles from "./styles.module.css";

const NotFoundListItem = ({ data }) => {
  const id = useId();
  const { title, list } = data;
  return (
    <div className={styles.wrapper}>
      <h3 className={styles.title}>{title}</h3>
      <ul>
        {list.map((item, index) => (
          <li key={`${id}${index}`}>
            <a href={`${item.slug}`}>{item.key}</a>
          </li>
        ))}
      </ul>
    </div>
  );
};

NotFoundListItem.propTypes = {
  data: PropTypes.object,
};

export default NotFoundListItem;
